import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { map, tap } from 'rxjs/operators';
import { Market } from '../models/market.model';
import { Utility } from '../../core/interceptor/utility';
import { Observable, of } from 'rxjs';
import { Order } from '../models/order.model';

@Injectable({
  providedIn: 'root'
})
export class MarketService {
  constructor(private http: HttpService) {
  }

  getMarkets(): Observable<Market[]> {
    const marketCacheTime = localStorage.getItem('marketsCacheTime');
    if (marketCacheTime && +marketCacheTime > new Date().getTime()) {
      const markets = JSON.parse(localStorage.getItem('markets') ?? '[]');
      return of(markets);
    } else {
      localStorage.removeItem('marketsCacheTime');
      localStorage.removeItem('markets');
    }
    return this.http.request('get', '/v1/market').pipe(
      map((response: any) => response.data),
      map((markets: any[]) =>
        markets.map((market) => {
          const marketsCamelize = Utility.camelize(market) as Market;
          marketsCamelize.baseCurrency = Utility.camelize(marketsCamelize.baseCurrency);
          marketsCamelize.quoteCurrency = Utility.camelize(marketsCamelize.quoteCurrency);
          return marketsCamelize;
        })
      ),
      tap(markets => {
        localStorage.setItem('markets', JSON.stringify(markets));
        localStorage.setItem('marketsCacheTime', `${new Date().getTime() + (10 * 60 * 1000)}`);
      })
    );
  }

  getMarketOrder(
    marketId: number = 1,
    status: 'PENDING' | 'COMPLETED' | 'INACTIVE' = 'PENDING',
    execution = 'LIMIT'
  ): Observable<any> {
    return this.http
      .request(
        'get',
        `/v1/admin/order?market_id=${marketId}&status=${status}&execution=${execution}`
      )
      .pipe(
        map((response: any) => response.data),
        map((orders: any[]) =>
          orders.map((order) => {
            const modeledOrder = Utility.camelize(order) as Order;
            modeledOrder.user = Utility.camelize(modeledOrder.user);
            return modeledOrder;
          })
        )
      );
  }
}
